export enum NOCStatus {
  Draft = 0,
  ReadyForEstimateIssue = 1,
  EstimateIssued = 2,
  EstimateApproved = 3,
  EstimateRejected = 4,
  InProgress = 6,
  WorkComplete = 7,
  ReadyForActualIssue = 8,
  ActualIssued = 9,
  ActualApproved = 10,
  ActualRejected = 11,
  Invoiced = 12,
  Cancelled = 13,
}

export const NOCStatusMetadata: {
  [key in NOCStatus]: { order: number; description: string; style: string; hidden: boolean };
} = {
  [NOCStatus.Draft]: { order: 0, description: 'Draft', style: 'badge-secondary', hidden: true },
  [NOCStatus.ReadyForEstimateIssue]: { order: 1, description: 'Est. Ready', style: 'badge-info', hidden: true },
  [NOCStatus.EstimateIssued]: { order: 2, description: 'Est. Issued', style: 'badge-primary', hidden: false },
  [NOCStatus.EstimateApproved]: { order: 3, description: 'Est. Approved', style: 'badge-success', hidden: false },
  [NOCStatus.EstimateRejected]: { order: 4, description: 'Est. Rejected', style: 'badge-danger', hidden: true },
  [NOCStatus.InProgress]: { order: 6, description: 'In Progress', style: 'badge-info', hidden: true },
  [NOCStatus.WorkComplete]: { order: 7, description: 'Work Complete', style: 'badge-success', hidden: true },
  [NOCStatus.ReadyForActualIssue]: { order: 8, description: 'Act. Ready', style: 'badge-info', hidden: true },
  [NOCStatus.ActualIssued]: { order: 9, description: 'Act. Issued', style: 'badge-primary', hidden: false },
  [NOCStatus.ActualApproved]: { order: 10, description: 'Act. Approved', style: 'badge-success', hidden: false },
  [NOCStatus.ActualRejected]: { order: 11, description: 'Act. Rejected', style: 'badge-danger', hidden: true },
  [NOCStatus.Invoiced]: { order: 12, description: 'Invoiced', style: 'badge-dark', hidden: true },
  [NOCStatus.Cancelled]: { order: 13, description: 'Cancelled', style: 'badge-light', hidden: true },
};

export const NOCStatusSorted = Object.entries(NOCStatusMetadata)
  .map(([key, value]) => ({
    status: Number(key) as NOCStatus,
    ...value,
  }))
  .filter(x => !x.hidden)
  .sort((a, b) => a.order - b.order);
